import { GetterTree } from 'vuex';
import { DiscussionModel } from '@/models/forumAPI/DiscussionModel';
import { DiscussionState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<DiscussionState, RootState> = {
  forumAPIDiscussionById: (state, discussionsGetters) => (discussionId: string) => {
    const discussion =
      state && state.paginatedDiscussions && state.paginatedDiscussions[discussionId];

    return discussion ? new DiscussionModel(discussion, discussionsGetters) : undefined;
  },
  discussionsByChannelId: (state, discussionsGetters) => (channelId: string) => {
    return Object.values(state.discussions)
      .map((discussion) => new DiscussionModel(discussion, discussionsGetters))
      .filter((discussion) => discussion.channelId === channelId);
  },
  paginatedDiscussionsByChannelId: (state, gettersDiscussions) => (channelId: string) => {
    return Object.values(state.paginatedDiscussions || [])
      .map((discussion) => new DiscussionModel(discussion, gettersDiscussions))
      .filter((discussion) => discussion.channelId === channelId);
  },
};

export default getters;
